import { useRecoilValue } from "recoil";
import { userManagementSearchAtom } from "../miscellaneous/userManagementSearchAtom";

export const useUserManagementSearchValue = () => {
  return useRecoilValue(userManagementSearchAtom);
};
